import { useContext } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { getInfoServiceIamos } from 'services/IAMOS';
import { getInfoService } from 'api/userApi';
import { FeatureContext } from 'components/AccessResolvers/featureContext';

interface IGetInfo {
  displayName: string;
  domain: string;
  email: string;
  firstName: string;
  lastName: string;
  loginId: string;
  multiProfile: boolean;
  nextivaUUID: string;
  profileDTO: {
    corpAcctNbr: number;
    userUuid: string;
  };
  profileId: string;
}

export const useGetInfo = (): UseQueryResult<IGetInfo, unknown> => {
  const {
    featureState: { authV3Enabled },
  } = useContext(FeatureContext);

  return useQuery(
    ['getInfo', authV3Enabled],
    authV3Enabled ? getInfoServiceIamos : getInfoService,
  );
};
